module.exports = __webpack_public_path__ + "static/media/grey-star-shape.14d1377d.svg";